import SegmentedInput from "@/components/SegmentedInput";
import { getListNegara } from "@/services/getData";
import React, { SetStateAction, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import InputError from "../../../../components/InputError";
import { Input } from "../../../../components/ui/input";
import { Label } from "../../../../components/ui/label";
import { ErrorType, InputRegistrasi, Negara } from "../../../../types";
import Combobox from "@/components/Combobox";
import { useTranslation } from "react-i18next";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

export default function FormRegistrasi({
  form,
  setForm,
  error,
}: {
  form: InputRegistrasi;
  setForm: React.Dispatch<SetStateAction<InputRegistrasi>>;
  error: ErrorType | null;
}) {
  const { t } = useTranslation();

  const [openNegara, setOpenNegara] = useState(false);

  const { data: dataNegara } = useQuery({
    queryKey: ["listNegara"],
    queryFn: () => getListNegara(),
    select: (data) =>
      data?.map((negara: Negara) => ({
        label: negara.nama_negara,
        value: `${negara.id_ref_negara}`,
      })),
  });

  const isIndonesia = form.data_siswa.id_ref_negara === "103";

  return (
    <div className="w-full mx-auto flex flex-col gap-y-3">
      <div>
        <Label>{t("guest.layout.register.label.kewarganegaraan")}</Label>
        <Combobox
          open={openNegara}
          setOpen={setOpenNegara}
          value={form.data_siswa.id_ref_negara || ""}
          setValue={(newValue) =>
            setForm((prev) => ({
              ...prev,
              data_siswa: { ...prev.data_siswa, id_ref_negara: newValue },
            }))
          }
          options={dataNegara}
          placeholder={`${t("guest.layout.register.label.kewarganegaraan")}`}
        />
        <InputError text={error?.errors?.id_ref_negara?.join(",")} />
      </div>
      {isIndonesia ? (
        <div>
          <Label>NIK (16 digit)</Label>
          <SegmentedInput
            type="number"
            length={16}
            value={form.data_siswa.nik}
            onComplete={(value: string) => {
              setForm((prev) => ({
                ...prev,
                data_siswa: { ...prev.data_siswa, nik: value },
              }));
            }}
          />
          <InputError text={error?.errors?.nik?.join(",")} />
        </div>
      ) : (
        <div>
          <Label>Pasport Number</Label>
          <Input
            required
            value={form.data_siswa.nik}
            placeholder="type Pasport Number"
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                data_siswa: { ...prev.data_siswa, nik: event.target.value },
              }))
            }
          />
          <InputError text={error?.errors?.nik?.join(",")} />
        </div>
      )}
      <div>
        <Label>{t("guest.layout.register.label.nama-lengkap")}</Label>
        <Input
          required
          value={form.nama_lengkap}
          placeholder={`type ${t("guest.layout.register.label.nama-lengkap")}`}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, nama_lengkap: event.target.value }))
          }
        />
        <InputError text={error?.errors?.nama_lengkap?.join(",")} />
      </div>
      {/* <div>
        <Label>NISN</Label>
        <Input
          required
          placeholder="Ketik NISN...."
          value={form.data_siswa.nisn}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              data_siswa: { ...prev.data_siswa, nisn: event.target.value },
            }))
          }
        />
        <InputError text={error?.errors?.nisn?.join(",")} />
      </div> */}
      <div>
        <Label>{t("guest.layout.register.label.handphone")}</Label>
        {isIndonesia ? (
          <Input
            required
            placeholder={`type ${t(
              "guest.layout.register.label.handphone",
            )}...`}
            value={form.data_siswa.handphone}
            pattern="\d*"
            inputMode="numeric"
            onInput={(event) => {
              event.currentTarget.value = event.currentTarget.value.replace(
                /\D/g,
                "",
              );
            }}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                data_siswa: {
                  ...prev.data_siswa,
                  handphone: event.target.value.replace(/\D/g, ""),
                },
              }))
            }
          />
        ) : (
          <PhoneInput
            placeholder="Enter phone number"
            value={form.data_siswa.handphone}
            onChange={(newValue) => {
              setForm((prev) => ({
                ...prev,
                data_siswa: { ...prev.data_siswa, handphone: newValue || "" },
              }));
            }}
            className="bg-secondary rounded-full py-2 px-3"
          />
        )}

        <p className="font-semibold text-sm text-muted-foreground">
          {t("guest.layout.register.label.handphone.description")}
        </p>
        <InputError text={error?.errors?.handphone?.join(",")} />
      </div>
      <div>
        <Label>{t("guest.layout.register.label.alamat")}</Label>
        <Input
          required
          placeholder={`type ${t("guest.layout.register.label.alamat")}...`}
          value={form.data_siswa.alamat}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              data_siswa: { ...prev.data_siswa, alamat: event.target.value },
            }))
          }
        />
        <InputError text={error?.errors?.alamat?.join(",")} />
      </div>
    </div>
  );
}
